import { useEffect, useState } from 'react';

export const MeshGradientBackground = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);
    
    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const animationClass = prefersReducedMotion ? '' : 'animate-';

  return (
    <div className="fixed inset-0 bg-black overflow-hidden" aria-hidden="true">
      {/* Blob 1: Large crimson - top right */}
      <div 
        className={`absolute w-[600px] h-[600px] -top-32 -right-32 
          bg-gradient-radial from-[hsl(0,100%,22%)] via-[hsl(0,100%,15%)] to-transparent 
          opacity-60 blur-[100px] ${prefersReducedMotion ? '' : 'animate-blob-1'}`}
      />
      
      {/* Blob 2: Navy blue - bottom left */}
      <div 
        className={`absolute w-[500px] h-[500px] -bottom-24 -left-24 
          bg-gradient-radial from-[hsl(229,30%,17%)] via-[hsl(229,40%,12%)] to-transparent 
          opacity-70 blur-[120px] ${prefersReducedMotion ? '' : 'animate-blob-2'}`}
      />
      
      {/* Blob 3: Deep purple accent - center floating */}
      <div 
        className={`absolute w-[400px] h-[400px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          bg-gradient-radial from-[hsl(285,45%,20%)] via-[hsl(285,50%,12%)] to-transparent 
          opacity-50 blur-[80px] ${prefersReducedMotion ? '' : 'animate-blob-3'}`}
      />

      {/* Blob 4: Warm accent - top left corner */}
      <div 
        className={`absolute w-[350px] h-[350px] -top-20 -left-20 
          bg-gradient-radial from-[hsl(15,80%,18%)] via-[hsl(15,70%,10%)] to-transparent 
          opacity-40 blur-[90px] ${prefersReducedMotion ? '' : 'animate-blob-4'}`}
      />

      {/* Subtle noise overlay for texture */}
      <div 
        className="absolute inset-0 opacity-[0.015]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />
    </div>
  );
};

export default MeshGradientBackground;
